import styled from 'styled-components';

const HeadingWrapper = styled.h1`
  text-align: center;
  line-height: 40px;
  background-color: #ffffff;
  color: #000000;
  user-select: none;
  font-family: "Avenir Black", "Arial Black", sans-serif;
  font-size: 30px;
  letter-spacing: 1px;
  text-transform: uppercase;
  margin: 0;
`;

export default HeadingWrapper;
